import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { of, catchError, map } from 'rxjs';
import { HubConnectionService } from 'src/app/shared/services/realtime-connection.service';
import { DocumentTypeBulkACStatusChangeNotifierHubMessage } from 'src/app/shared/services/realtime-constants';
import { ComplianceReportClient } from '../../api/compliance-report-client.service';
import { showToasterMessage } from 'src/app/shared/actions/toaster.actions';
import { Owner } from 'src/app/shared/helpers/owner.decorator';

@Owner('Mic Drop')
@Injectable()
export class ComplianceDocumentTypeBulkACStatusChangeEffects {
    constructor(
        private readonly _hubConnectionService: HubConnectionService,
        private readonly complianceReportClient: ComplianceReportClient
    ) {}

    getAutoMatchResponseFromMessagesOfSignalR$ = createEffect(() =>
        this._hubConnectionService.documentTypeBulkACStatusChangeNotifierHub
            .messagesOf<string>(DocumentTypeBulkACStatusChangeNotifierHubMessage.SENT_STATUS)
            .pipe(
                map((message) => {
                    return showToasterMessage({ message });
                }),
                catchError((error) => {
                    console.error('Error in SignalR effect:', error);
                    return of(showToasterMessage({ message: 'Error receiving SignalR message' }));
                })
            )
    );
}
